module.exports = __webpack_public_path__ + "static/media/projector.10166678.svg";